import React from 'react';
import './button.scss';

export const Button = React.forwardRef(({
    className = '',
    variant = 'default',
    children,
    disabled,
    type = 'button',
    ...props
}, ref) => {
    return (
        <button
            ref={ref}
            type={type}
            className={`btn btn-${variant} ${className}`}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    );
});

Button.displayName = 'Button';
